module.exports = __webpack_public_path__ + "static/media/img_55.573e7439.png";